<template>
	<v-card outlined class="p-4">
		<v-card-title class="text-h6">
			CO2 Emissions Divided Per Scope 1, 2, and 3 in Relation to Number of
			Employees
		</v-card-title>
		<v-card-text>
			<div class="chart-container">
				<canvas ref="emissionChart"></canvas>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import Chart from "chart.js"

export default {
	name: "EmissionDualAxisChart",
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	mounted() {
		const ctx = this.$refs.emissionChart.getContext("2d")

		// Chart.js v2.9.4 Configuration for Stacked Bars and Line Chart
		new Chart(ctx, {
			type: "bar",
			data: {
				labels: this.data.labels, // Year labels
				datasets: [
					{
						label: "Total Emissions Scope 1",
						data: this.data.scope1,
						backgroundColor: "rgba(0, 123, 255, 0.7)", // Blue
						yAxisID: "y-axis-left",
					},
					{
						label: "Total Emissions Scope 2",
						data: this.data.scope2,
						backgroundColor: "rgba(255, 153, 0, 0.7)", // Orange
						yAxisID: "y-axis-left",
					},
					{
						label: "Total Emissions Scope 3",
						data: this.data.scope3,
						backgroundColor: "rgba(40, 167, 69, 0.7)", // Green
						yAxisID: "y-axis-left",
					},
					{
						label: "Number of Employees",
						data: this.data.employees,
						type: "line",
						borderColor: "#000", // Black
						borderWidth: 2,
						fill: false,
						lineTension: 0.4,
						yAxisID: "y-axis-right",
					},
				],
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				scales: {
					xAxes: [
						{
							stacked: true,
						},
					],
					yAxes: [
						{
							id: "y-axis-left",
							stacked: true,
							position: "left",
							scaleLabel: {
								display: true,
								labelString: "CO2e",
							},
							ticks: {
								beginAtZero: true,
							},
						},
						{
							id: "y-axis-right",
							position: "right",
							scaleLabel: {
								display: true,
								labelString: "Number of Employees",
							},
							gridLines: {
								drawOnChartArea: false,
							},
							ticks: {
								beginAtZero: true,
							},
						},
					],
				},
				legend: {
					display: true,
					position: "top",
				},
				tooltips: {
					mode: "index",
					intersect: false,
				},
			},
		})
	},
}
</script>

<style scoped>
.chart-container {
	width: 100%;
	height: 500px; /* Adjusted for smaller height */
}
.v-card {
	max-width: 800px; /* Limits card width for better aesthetics */
	margin: 0 auto; /* Center the card */
}
</style>
